import { identityActions } from '../../services';
import { extractDataFromJwt, UserIdentity } from '../../util';

export const identityReducer = ( state = { hasCart: false, useLocalCart: false, name: 'guest' }, action = {} ) => {
  switch ( action.type ) {
    case identityActions.LOAD:
      UserIdentity.jwt = action.data;
      const payload = extractDataFromJwt( action.data );
      return Object.assign( { }, payload.content );
    case identityActions.UPDATE:
      return Object.assign( { }, action.data );
    default:
      return state;
  }
};